import { useEffect,useState,useRef } from 'react';
import { useLocation } from 'react-router-dom';
import './App.css';
import { Footer, NavPages } from './Layouts';
import { Home, ServiceList, ServiceDetails } from './Pages';
import { Loading } from './Components/index';
import { BrowserRouter,Routes, Route } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import axios from "axios";
import Cookies from 'js-cookie';
import faviconLogo from "./Assets/Images/gold-logo.png"
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';


function App() {

  useEffect(() => {
    AOS.init({
      duration: 1300,
      once: true,
      mirror: false, 
    });
  }, []);

  const [loading, setLoading] = useState(true);
  const url = "https://whatsapptest.inter-netsys.com";
  const apiMethod = "/api/method/geniusapi.www.api";
  const limit = 8;
  const pageUrl = window.location.pathname;
  const lastWordIndex = pageUrl.lastIndexOf("/") + 1;
  const pathParts = pageUrl.split("/").filter(Boolean);

  let pageName = pathParts[0] || "home";

  const [logos, setLogos] = useState({});
  const [services, setServices] = useState([]);
  const [data, setData] = useState([]);
  const [servicesData, setServicesData] = useState([]);
  const [page_title, setPageTitle] = useState();
  const [contentData, setContentData] = useState({});

  const [innerPageData, setInnerPageData] = useState({});
  const [seoSettingsData, setSeoSettingsData] = useState({});
  const firstRender = useRef(true);

  const [language, setLanguage] = useState(Cookies.get('preferred_language')??"en"); 
  const [translations, setTranslations] = useState(localStorage.getItem('translations')?JSON.parse(localStorage.getItem('translations')):{});
  // const location = useLocation();
  const isServiceDetailsPage = false;
  const fetchTranslations = async (lang) => {
    try {
      const response = await fetch(`${url}/api/method/geniusapi.www.api.get_translation_file?lang=${lang}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
    
      if (!response.ok) {
        toast.error(`HTTP error! status: ${response.status}`);
        return;
      }
  
      const data = await response.json();
      setTranslations(data);
      localStorage.setItem('translations', JSON.stringify(data));
    } catch (error) {
      console.error(`Error fetching translations: ${error}`);
    }
  };
  
  const changeLang = async (lang) => {    
    try {
      const response = await axios.post(`${url}/api/method/geniusapi.www.api.set_language?name=${lang}`);  
      if (response.data && response.data.message === "Success") {
        Cookies.set("preferred_language", lang);  
        setLanguage(lang);  
        await fetchTranslations(lang); 
      } else {
        toast.error('Failed to change language');
      }
    } catch (error) {
      console.error(`Error changing language: ${error}`);
    }
  };



  useEffect(() => {
    const preferredLanguage = Cookies.get("preferred_language");
    // if (language !== preferredLanguage) {
      changeLang(language); 
      if (pageName !== "details") {
        fetchWebsiteData(pageName);
      } else {
        // console.log("___________________________-");
      }
    // }
  }, [language]);



  useEffect(() => {
    if (pageName !== "details") {
      fetchWebsiteData(pageName);
    } else {
      setLoading(false);
      
    }
  }, [pageName]);

  // useEffect(() => {
  //   if (!["", "/", "home"].includes(pageName)) {
  //     setLoading(false);
  //     return;
  //   }
  // }, []);

  // useEffect(() => {
  //   if (!["", "/", "home"].includes(pageName)) {
  //     setLoading(false);
  //   }
  // }, [pageName]);

  const fetchWebsiteData = async (pageName) => {
    console.log("pagename:",pageName )
    let _pageName = pageName.toLowerCase();
    if (_pageName == "home"){
      _pageName = "servicesHome";
    }
    
    setLoading(true);
    const apiKey = Cookies.get('api_key');
    const apiSecret = Cookies.get('api_secret');
    var headers = { 'Content-Type': 'application/json' };
    try {
      let apiUrl = `${url}/api/method/geniusapi.genius_api.doctype.pages.pages.page?name=${_pageName}`;
   
      const response = await axios.get(apiUrl, { headers: headers });
  
      setData(response?.data?.result?.content?.templates || [] );
      setServicesData(response?.data?.result || [] );
      setServices(response?.data?.result?.content?.services || [] );
      setPageTitle(response?.data?.result?.page_title || "");
      setTimeout(() => {
        setLoading(false);
      }, 3000);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
  }, [data, services]);
  

  useEffect(() => {
    const updateFavicon = () => {
      const link = document.querySelector('link[rel="icon"]') || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'icon';
      link.href = `${logos?.logo_favicon || faviconLogo}`;
      document.head.appendChild(link);
    };

    const updateTitle = () => {
      const mainTitle = `${seoSettingsData?.main_title || ""} ${seoSettingsData?.separator || ""
        } ${innerPageData?.name || ""}`;
      const formattedTitle = mainTitle.trim() || "Genuis";
      if (formattedTitle === undefined) document.title = "Genuis";
      else {
        document.title = formattedTitle;
      }
    };

    updateFavicon();
    updateTitle();
  }, [logos, pageName, seoSettingsData, innerPageData]);

  return (
    
    <div className={`App ${language === "ar" ? "rtl" : "ltr"}`}>
              <BrowserRouter>

      <NavPages 
        translations={translations}
        language={language}
        setLanguage={setLanguage}
      />

      {loading ? (
        <>
          <Loading />
        </>
      ) : (

        <Routes>
          <Route
            index 
            element={
              <Home 
                url={url} 
                data={data}  
                translations={translations} 
                language={language}
              />
            } 
          />
          <Route 
            path='/home' 
            index 
            element={
              <Home 
                url={url} 
                data={data}  
                translations={translations} 
                language={language}
              />
            } 
          />
          <Route 
            path='/services' 
            index 
            element={
              <ServiceList 
                url={url} 
                data={data} 
                services={services} 
                servicesData={servicesData} 
                translations={translations} 
                language={language}
              />
            } 
          />
          <Route 
            path='/details/:serviceName' 
            index 
            element={
              <ServiceDetails 
                url={url}  
                translations={translations} 
                language={language} 
                loading={loading}
                setLoading={setLoading}
              />
            } 
          />
        </Routes>

      )}

      <Footer translations={translations} />
      </BrowserRouter>

    </div>
  );
}

export default App;

  //   <div className={`App ${language === "ar" ? "rtl" : "ltr"}`}>
  //   <BrowserRouter>
  //     {loading ? (
  //       <div>
  //         <NavPages
  //           url={url}
  //           translations={translations}
  //           language={language}
  //           setLanguage={setLanguage}
  //         />
  //         <Loading></Loading>
  //         <Footer translations={translations} />
  //       </div>
  //     ) : (
  //       <>
  //         <NavPages
  //           url={url}
  //           translations={translations}
  //           language={language}
  //           setLanguage={setLanguage}
  //         />
  //         <Routes>
  //         <Route 
  //           path='/servicesHome' 
  //           index 
  //           element={
  //             <Home 
  //               url={url} 
  //               data={data}  
  //               translations={translations} 
  //               language={language}
  //             />
  //           } 
  //         />
  //         <Route 
  //           path='/services' 
  //           index 
  //           element={
  //             <ServiceList 
  //               url={url} 
  //               data={data} 
  //               services={services} 
  //               servicesData={servicesData} 
  //               translations={translations} 
  //               language={language}
  //             />
  //           } 
  //         />
  //         <Route 
  //           path='/details/:serviceName' 
  //           index 
  //           element={
  //             <ServiceDetails 
  //               url={url}  
  //               translations={translations} 
  //               language={language} 
  //               loading={loading}
  //               setLoading={setLoading}
  //             />
  //           } 
  //         />

  //         </Routes>
  //         <Footer translations={translations} />
  //       </>
  //     )}
  //   </BrowserRouter>
  // </div>

